import { graphql } from '@/gql';

export const FetchCourses = graphql(`
    query FetchCourses {
        courseInstances {
            count
            items {
                id
                name
                description
            }
        }
    }
`);
